module.exports = __webpack_public_path__ + "static/media/limkokwing-com.1d03c975.png";